import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import {
	getUseCaseIcon,
	type ConversationAction,
	type PromptCard,
} from '@atlassian/rovo-conversation-actions';
import { HandleActionType } from '@atlassian/rovo-conversation-actions/types';

const MAX_EMPTY_PAGE_ACTIONS = 3;

/* istanbul ignore next */
const styles = cssMap({
	iconContainer: {
		padding: token('space.075'),
	},
});

export const getEmptyPageCreationActions = (promptCards: PromptCard[]): ConversationAction[] => {
	return promptCards.slice(0, MAX_EMPTY_PAGE_ACTIONS).map((card) => ({
		handleType: HandleActionType.Chat,
		id: card.id,
		title: card.title,
		dynamicPrompt: card.prompt,
		icon: () => {
			const Icon = getUseCaseIcon(card.useCase);
			return (
				<Flex alignItems="center" justifyContent="center" xcss={styles.iconContainer}>
					<Icon />
				</Flex>
			);
		},
	}));
};
